import { useState, useEffect } from 'react';

const useCountryCode = () => {
  const [countryCode, setCountryCode] = useState('AE'); // Default to 'US' initially
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getCountryCode = async (latitude, longitude) => {
      try {
        // Use a reverse geocoding service to get the country code
        const response = await fetch(
          `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
        );
        const data = await response.json();
        if (data && data.countryCode) {
          setCountryCode(data.countryCode);
        }
      } catch (error) {
        console.error('Error fetching country data:', error);
      } finally {
        setLoading(false);
      }
    };

    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            getCountryCode(latitude, longitude);
          },
          (error) => {
            console.error('Error getting location:', error);
            setLoading(false);
          }
        );
      } else {
        console.error('Geolocation is not supported by this browser.');
        setLoading(false);
      }
    };

    getLocation();
  }, []);

  return { countryCode, loading };
};

export default useCountryCode;
